import { useState } from "react";

const usePinReservationStudent = ({
	clearFoundStudentList,
	$content,
	studentReservations,
}) => {
	const [pinnedStudentId, setPinnedStudentId] = useState(null);
	const findStudentReservationById = studentId => {
		return studentReservations.value.find(({ id }) => id === studentId);
	};
	const removeAndStackStudentReservation = studentId => {
		const foundReservation = findStudentReservationById(studentId);
		const filtered = studentReservations.value.filter(
			({ id }) => id !== foundReservation.id
		);
		filtered.unshift(foundReservation);
		studentReservations.set(filtered);
	};
	const scrollToTableTop = () => {
		$content.current.querySelector("table").parentElement.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	function clearStudentPinId() {
		setTimeout(() => {
			setPinnedStudentId(null);
		}, 1000);
	}
	function pinStudentReservation(studentId) {
		clearFoundStudentList();
		removeAndStackStudentReservation(studentId);
		scrollToTableTop();
		setPinnedStudentId(studentId);
		clearStudentPinId();
	}
	function isPinned(studentId) {
		return studentId === pinnedStudentId;
	}
	return {
		isPinned,
		pin: pinStudentReservation,
	};
};

export default usePinReservationStudent;
